var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box2"},[_c('div',{staticClass:"complaintInformation"},[_c('div',{staticClass:"complaintOder border_bottom"},[_c('div',{staticClass:"left"},[_vm._v("投诉分类")]),_c('div',{staticClass:"right"},[_c('span',[_vm._v("请选择 >")])])])])])])
}]

export { render, staticRenderFns }